import React, { useEffect, useState } from 'react';
import { FileText, Globe, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import '../InvoiceModal/InvoiceModal.css';
import './ConsolidatedOrderLanguageModal.css';

const SUPPORTED_LANGUAGES = ['fr', 'en', 'pt'];
const LANGUAGE_OPTIONS = [
  { value: 'fr', label: 'Français' },
  { value: 'en', label: 'English' },
  { value: 'pt', label: 'Português' },
];

const normalizeLanguage = (language) => {
  const baseLanguage = String(language || '')
    .toLowerCase()
    .split('-')[0];
  return SUPPORTED_LANGUAGES.includes(baseLanguage)
    ? baseLanguage
    : 'fr';
};

const ConsolidatedOrderLanguageModal = ({
  isOpen,
  initialLanguage,
  loading,
  onClose,
  onGenerate,
}) => {
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(
    normalizeLanguage(initialLanguage)
  );

  useEffect(() => {
    if (isOpen) {
      setSelectedLanguage(normalizeLanguage(initialLanguage));
    }
  }, [initialLanguage, isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="dialog-overlay" onClick={loading ? undefined : onClose}>
      <div
        className="dialog-container invoice-modal-container consolidated-language-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="consolidated-language-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="dialog-header">
          <div className="dialog-title">
            <FileText size={22} />
            <h2 id="consolidated-language-title">
              {t('sessions.detail.consolidatedLanguageTitle')}
            </h2>
          </div>
          <button
            type="button"
            className="dialog-close"
            onClick={onClose}
            disabled={loading}
            aria-label={t('common.close')}
          >
            <X size={20} />
          </button>
        </div>

        <div className="dialog-form">
          <p>{t('sessions.detail.consolidatedLanguageHelp')}</p>
          <div className="invoice-lang-section">
            <div className="invoice-lang-label">
              <Globe size={16} />
              {t('invoice.modal.language')}
            </div>
            <div className="invoice-lang-options">
              {LANGUAGE_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className={`invoice-lang-btn ${
                    selectedLanguage === option.value ? 'active' : ''
                  }`}
                  aria-pressed={selectedLanguage === option.value}
                  onClick={() => setSelectedLanguage(option.value)}
                  disabled={loading}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          <div className="dialog-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              {t('common.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => onGenerate(selectedLanguage)}
              disabled={loading}
            >
              {loading
                ? t('sessions.detail.generatingConsolidatedInvoice')
                : t('sessions.detail.generateConsolidatedInvoice')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsolidatedOrderLanguageModal;
